import { useCallback, useEffect, useState } from 'react';

import { fetchMonthlyMessagesCount } from '../fetchers/monthlyMessagesCount';
import { sendExceptionToSentry } from '@api/sentry/client';

/**
 *
 * @param [props]
 * @param {boolean} props.enabled - indicates whether query should be run automatically or not. Defaults to `true`
 *
 * @returns {{
 *   data: unknown | null;
 *   refetch: () => Promise<unknown>;
 *   loading: boolean;
 *   error: Error | null;
 * }}
 */
export function useMonthlyMessagesCountQuery({ enabled = true } = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refetch = useCallback(async () => {
    setLoading(true);

    try {
      const resp = await fetchMonthlyMessagesCount();
      const jsonData = await resp.json();

      setData(jsonData);
    } catch (e) {
      sendExceptionToSentry(e, 'Error in useMonthlyMessagesCountQuery');

      setError(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    refetch();
  }, [enabled, refetch]);

  return {
    data,
    refetch,
    loading,
    error,
  };
}
